<template>
  <div
    class="flex flex-wrap md:flex-nowrap border-b-[1px] border-solid border-[#4c5658] text-[15px] text-[#828585] min-h-[60px] items-center py-4 md:py-0 gap-2"
  >
    <div class="flex-1">
      Color
    </div>
    <div class="flex flex-wrap items-center gap-2 py-0 md:py-2">
      <user-color
        v-for="color in colors"
        :key="color"
        :color="color"
        :selected="color === userColor"
      />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import UserColor from './UserColor.vue';

export default {
  components: {
    UserColor,
  },
  setup() {
    const store = useStore();

    const colors = computed(() => store.getters['settings/getColors']);
    const userColor = computed(() => store.getters['user/account/getColor']);

    return {
      colors,
      userColor,
    };
  },
};
</script>
